import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Popup } from './popup.model';

@Injectable({ providedIn: 'root' })
export class PopupService {
  private _httpClient = inject(HttpClient);
  private _backendUrl = environment.backendUrl;

  getActive(): Observable<Popup | null> {
    return this._httpClient
      .get<any>(`${this._backendUrl}client/popup/active`)
      .pipe(
        map((res) => res?.payload?.popup || null),
        catchError(() => of(null)),
      );
  }

  private storageKey(popup: Popup): string {
    return `artstgo_popup_${popup._id}_${popup.updatedAt}_seen_at`;
  }

  wasRecentlyShown(popup: Popup): boolean {
    try {
      const seenAt = localStorage.getItem(this.storageKey(popup));
      if (!seenAt) return false;
      const seenAtDate = new Date(seenAt);
      const cooldownMs = popup.cooldownHours * 60 * 60 * 1000;
      return Date.now() - seenAtDate.getTime() < cooldownMs;
    } catch {
      // Safari ITP estricto / incognito puede lanzar al leer localStorage.
      // Degradación aceptable: tratar como "no visto" → el popup aparece esta sesión.
      return false;
    }
  }

  markShown(popup: Popup): void {
    try {
      localStorage.setItem(this.storageKey(popup), new Date().toISOString());
    } catch {
      // Silenciar — el cooldown no persiste pero la app no crashea.
    }
  }
}
